import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import './Items.css';

class Items extends React.Component {
  render() {
    return (
      <ul
        className={this.props.className === undefined? "nav-items" : this.props.className + " nav-items"}
        onClick={this.props.onClick}
      >
        {
          this.props.items.map((item, index) => {
            return (
              <li key={index}>
                <Link to={item.path}
                  onClick={() => this.forceUpdate()}
                  style={{
                    textDecoration: this.props.location.pathname === item.path 
                      ? "line-through"
                      :"none"
                  }}
                >
                  {item.content}
                </Link>
              </li>
            );
          })
        }
      </ul>
    )
  }
}


export default withRouter(Items);